import { FormControlBase } from '../models';
import { DropdownOption } from '../models/dropdown-option.model';
import { FormControlTypeEnum } from '../models/form-control-type.enum';

export class FormControlDropdown extends FormControlBase<string> {
	public controlType = FormControlTypeEnum.Dropdown;
	public options: DropdownOption[];
	public selectedOption: DropdownOption;
	public refTableName: string;
	public refTableColumnDescription: string;
	public refTableColumnValue: string;

	public constructor(fcd: Partial<FormControlDropdown>) {
		super(fcd);
		this.refTableName = fcd.refTableName;
		this.refTableColumnDescription = fcd.refTableColumnDescription;
		this.refTableColumnValue = fcd.refTableColumnValue;
	}
}
